export default __webpack_public_path__ + "static/media/pink-book.624ac721.png";